<template>
  <svg class="ruble_ico" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
  <!--! Font Awesome Free 6.0.0-beta2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) -->
    <path d="M240 320c79.41 0 144-64.59 144-144S319.4 32 240 32H96C78.33 32 64 46.33 64 64v192H32C14.33 256 0 270.3 0 288s14.33 32 32 32h32v32H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h32v32c0 17.67 14.33 32 32 32s32-14.33 32-32v-32h160c17.67 0 32-14.33 32-32s-14.33-32-32-32H128v-32H240zM128 96h112C284.1 96 320 131.9 320 176S284.1 256 240 256H128V96z"/>
  </svg>
</template>

<script>
export default {
  name: 'Ruble'
}
</script>

<style lang="stylus">
  .ruble_ico {
    width 14px
    height auto

    > path {
      fill #979797
    }
    // path[stroke] {
    //   stroke $red
    // }

    // path[fill] {
    //   fill $red
    // }
  }
</style>
